import useTable from '../../../hooks/useTable';
import { Table } from '../../Table';
import { TableComponentProps } from '../types';

const columnLables = {
  first_funding_source_country: {
    name: 'First funding source country',
    order: 54
  },
  second_funding_source_country: {
    name: 'Second funding source country',
    order: 55
  },
  third_funding_source_country: {
    name: 'Third funding source country',
    order: 56
  }
};

export function FundSourceCode({
  funds,
  currentDataKey,
  onChangeFund,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useTable({
    data: funds[currentDataKey]?.fund_data?.FUNDING_SOURCE_COUNTRY_CODE,
    onChangeFund,
    schema: schema.FUNDING_SOURCE_COUNTRY_CODE,
    isStaticTemplate,
    requiredFields:
      funds[currentDataKey]?.required_tables?.FUNDING_SOURCE_COUNTRY_CODE?.field_names || [],
    isMultiFunds,
    funds,
    columnLables,
    tableName: 'FUNDING_SOURCE_COUNTRY_CODE'
  });

  return (
    <Table
      id="reporttables-fund-source-code-table"
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
      handleChanges={onChange}
      columns={columns}
      rows={rows}
    />
  );
}
